import React from 'react';
import { Box, Card, CardContent, Divider, Grid, Stack, Typography } from '@mui/material';
import { Icon } from '@iconify/react';
import type { ActivityFeedItem } from '../../services/activityFeedService';
import type { ActivityFeedFilterOption } from '../../types/activityFeed';
import ActivityFeedSection from './ActivityFeedSection';
import { adminColors } from '../../styles/adminDesignTokens';
import {
  adminCardContentSx,
  adminCombineSx,
  adminDividerSx,
  adminIconTitleSx,
  adminSurfaceSx,
} from '../../styles/adminComponentStyles';

type StoreInfoCardProps = {
  activityDateRange: [Date | null, Date | null];
  onActivityDateRangeChange: (range: [Date | null, Date | null]) => void;
  activityEventType: string;
  activityEventCategory: string;
  activityEventTypeOptions: ActivityFeedFilterOption[];
  activityEventCategoryOptions: ActivityFeedFilterOption[];
  onActivityEventTypeChange: (eventType: string) => void;
  onActivityEventCategoryChange: (eventCategory: string) => void;
  activityFeedLoading: boolean;
  activityFeedLoadingMore: boolean;
  activityFeedHasMore: boolean;
  activityFeed: ActivityFeedItem[];
  onActivityFeedScroll: (event: React.UIEvent<HTMLDivElement>) => void;
  getAvatarColor: (name: string) => string;
  getInitials: (name: string) => string;
};

const StoreInfoCard: React.FC<StoreInfoCardProps> = ({
  activityDateRange,
  onActivityDateRangeChange,
  activityEventType,
  activityEventCategory,
  activityEventTypeOptions,
  activityEventCategoryOptions,
  onActivityEventTypeChange,
  onActivityEventCategoryChange,
  activityFeedLoading,
  activityFeedLoadingMore,
  activityFeedHasMore,
  activityFeed,
  onActivityFeedScroll,
  getAvatarColor,
  getInitials,
}) => {
  return (
    <Grid size={{ xs: 12, md: 5 }} sx={{ order: { xs: 2, md: 2 } }}>
      <Card
        elevation={0}
        sx={adminCombineSx(adminSurfaceSx, { height: '100%' })}
      >
        <CardContent
          sx={adminCombineSx(adminCardContentSx, { '&:last-child': { pb: 0.5 } })}
        >
          <Box sx={{ backgroundColor: '#F8FBFF', mx: -2, mt: -2, px: 2, pt: 1.5, pb: 1, mb: 2, borderBottom: '1px solid #e0e0e0' }}>
            <Stack
              direction="row"
              spacing={1}
              alignItems="center"
              justifyContent="space-between"
              sx={adminCombineSx(adminIconTitleSx, { mb: 0 })}
            >
              <Stack direction="row" spacing={1} alignItems="center" sx={{ minWidth: 0 }}>
                <Box className="AdminIconTitle-icon">
                  <Icon icon="material-symbols:history-rounded" width="20" height="20" style={{ color: adminColors.primary }} />
                </Box>
                <Typography className="AdminIconTitle-title" sx={{ color: `${adminColors.primary} !important` }}>
                  Activity Feed
                </Typography>
              </Stack>
            </Stack>
          </Box>

          <ActivityFeedSection
            activityDateRange={activityDateRange}
            onActivityDateRangeChange={onActivityDateRangeChange}
            activityEventType={activityEventType}
            activityEventCategory={activityEventCategory}
            activityEventTypeOptions={activityEventTypeOptions}
            activityEventCategoryOptions={activityEventCategoryOptions}
            onActivityEventTypeChange={onActivityEventTypeChange}
            onActivityEventCategoryChange={onActivityEventCategoryChange}
            activityFeedLoading={activityFeedLoading}
            activityFeedLoadingMore={activityFeedLoadingMore}
            activityFeedHasMore={activityFeedHasMore}
            activityFeed={activityFeed}
            onActivityFeedScroll={onActivityFeedScroll}
            getAvatarColor={getAvatarColor}
            getInitials={getInitials}
          />
        </CardContent>
      </Card>
    </Grid>
  );
};

export default React.memo(StoreInfoCard);
